import React, { useState, useEffect } from 'react';
import { ThemeProvider } from "@material-ui/core"
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Link } from "react-router-dom";
//import DataTable from './DataTable';
//import PlannedIdleTime from './PlannedIdleTime';
//import UnplannedIdleTime from './UnplannedIdleTime';
//import IHFTime from './IHFTime';
import { useSelector, useDispatch } from "react-redux";
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import axios from 'axios';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
//Autocomplete
import Autocomplete from '@material-ui/lab/Autocomplete';
import MaterialTable from "material-table";
//import { tableOptionsUser } from "../../SharedComponents/SharedComponentStyles";
import { forwardRef } from "react";
import {
    AddBox,
    Check,
    DeleteOutline,
    Edit,
    SaveAlt,
    FilterList,
    FirstPage,
    LastPage,
    ChevronRight,
    ChevronLeft,
    Clear,
    Search,
    ArrowDownward,
    Remove,
    ViewColumn,
} from "@material-ui/icons";


const api = axios.create({
    baseURL: 'PhyInvUser'
})



export const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => (
        <DeleteOutline {...props} ref={ref} style={{ color: "var(--red)" }} />
    )),
    DetailPanel: forwardRef((props, ref) => (
        <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
        <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => (
        <Search {...props} ref={ref} style={{ fontSize: "2.5rem" }} />
    )),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
//const useStyles = makeStyles((theme: Theme) =>
//    createStyles({
//        container: {
//            display: 'flex',
//            flexWrap: 'wrap',
//        },
//    }),
//);



export default function UpdateUserMgnt(props) {
   
    const [plantDNames, setPlantDNames] = useState(props.plantNameData);
   
    const [allRolesData, setAllRolesData] = useState(props.userRolesData);
   
    const [editedrowData, setEditedrowData] = useState(props.editData);
   
    ///editData
   
     const [data, setData] = useState();
    //const data = [
    //    {
    //        id: "12345678",
    //        firstName: "0001-HFHJS",
    //        lastName: "16.5",
    //        emailId: "sriyanka",
    //        phone: "9/01/2023  10:12:23",

    //    }
    //];
    const [alertsuccess, setalertsuccess] = useState("Success");
    //const [CreatedUserId, setCreatedUserId] = useState(props.createdUserId);
    
    const clear = () => {
        setUpdateUserId("");
        setUpdateUserName("");
        setUpdateUserEmailId("");
        setUpdateRolesId("");
        setUpdatePlantId("");
        setUpdatePlantName("");
        setUpdateRolesName("");

    }
   
   
    const [updateUserId, setUpdateUserId] = useState(editedrowData.userId);
    const [updateUserName, setUpdateUserName] = useState( editedrowData.userName);
    const [updateUserEmailId, setUpdateUserEmailId] = useState(editedrowData.emailAddress);
    const [updatePlantName, setUpdatePlantName] = useState(editedrowData.plantName);
    const [updatePlantId, setUpdatePlantId] = useState(editedrowData.plantId);
    const [updateRolesId, setUpdateRolesId] = useState(editedrowData.userRoleId);
    const [updateRolesName, setUpdateRolesName] = useState(editedrowData.userRoleName);
    const handleUpdateUserId = (e) => {
       
        setUpdateUserId(e.target.value);
    }
    const handleUpdateUserName = (e) => {
        
        setUpdateUserName(e.target.value);
    }
    const handleUpdateUserEmailId = (e) => {
        //setPlantId(""),setPlantName("");userRoleName("")
        setUpdateUserEmailId(e.target.value);
    }
    const handleUpdatePlantName = (e) => {
        
        setUpdatePlantId(e.target.value);

        plantDNames.map((x) => {
            if (x.plantId === e.target.value) {
                setUpdatePlantName(x.plantName);

            }

        })
    }

    const handleUpdateRolesId = (e) => {
        
        setUpdateRolesId(e.target.value);
        allRolesData.map((x) => {
            if (x.roleId === e.target.value) {
                setUpdateRolesName(x.name);

            }
        })
    }
    //const classes = useStyles();
    const [open, setopen] = useState(false);
    const [openAlert, setopenAlert] = useState("");
    const [openClassName, setopenClassName] = useState("");
    const [alertsuccessclass, setalertsuccessclass] = useState("");
    const [openType, setopenType] = useState("");

    //for progress
    var columns = [
        { title: "Slip Number", field: "id" },
        { title: "Location", field: "firstName" },
        { title: "Entered Quantity", field: "lastName" },
        { title: "Entered By", field: "emailId" },
        { title: "Entered On", field: "phone" },

    ];

    const [openLoader, setopenLoader] = useState(false);
    //const [data, setData] = useState();

    //for Warning showing
   

    //for error handling 
    const [iserror, setIserror] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    //const [severity, setSeverity] = useState('success');
    const [canShowHelperText, setCanShowHelperText] = useState(false);
    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
      (state) => state.storeUserDetailsReducer.userData
    );
    const bearerToken = useSelector(
      (state) => state.saveBearerTokenReducer.bearerToken
    );
    const uId = useSelector((state) => state.saveUIDReducer.uid);

   
  

    const handleErrorClose = (e) => {
        setIserror(false);
    }

    //const [getAllDetailsData, setGetAllDetailsData] = useState([]);
    function getAllDetails() {
        //setopenLoader(true);
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api.get("/GetUserDetails/",{
            headers: headers,
        })
            .then(res => {
               
                props.setGetAllDetailsData1(res.data);
                //setGetAllDetailsData(res.data);
                //setopenLoader(false);
            })
            .catch(error => {
                console.log("Error in hitting api : GetUserDetails!!")
                //setopenLoader(false);
            })
    }
    function validateEmail(email) {

        var reg = (/^\w+([\.-]?\w+)*@siemens.com$/);
        return reg.test(email);
        //var address = document.getElementById[email].value;
        //if (reg.test(email) == false) {
        //    alert('Invalid Email Address');
        //    return (false);
        //}
    }
   

   

    
   
    const tableHeaderStyle = {
        backgroundColor: "var(--light-sand)",
        color: "var(--dark-blue)",
    };
    const tableOptions = {
        headerStyle: tableHeaderStyle,
        showTitle: false,
        draggable: false,
        pageSize: 5,
        pageSizeOptions: [5, 10, 25, 50],
        paginationPosition: "bottom",
        //paging: false,
        maxBodyHeight: '600px',
        // exportButton: true,
        // exportAllData: true
    };
    function getURLParameter(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            var value = getParamName(sParameterName, sParam);
            return value;
        }
    }

    function getParamName(sParameterName, sParam) {
        var value = '';
        for (var j = 0; j < sParameterName.length; j++) {
            if (sParameterName[j] == sParam) {
                value = value + getParanValue(j, sParameterName);
                break;
            }
            else {
                continue;
            }
        }
        return value;
    }

    function getParanValue(j, sParameterName) {
        var value = '';
        for (var k = j + 1; k < sParameterName.length; k++) {
            value = value + sParameterName[k];
        }
        return value;
    }

   






    const [severity, setSeverity] = useState('success');
    //function showMessage(errorList, flag, severity) {
    //    setErrorMessages(errorList);
    //    setIserror(flag);
    //    setSeverity(severity);
    //}





   


    function handleClose() {
        //setopen(false);
    }


    function backClick() {
        props.clickgoback(null);
    }

    //NEW FUNCS
    function showMsg(popen, popenAlert, popenClassName, popenType) {
        setopen(popen);
        setopenAlert(popenAlert);
        setopenClassName(popenClassName);
        setopenType(popenType);
    }
    
    function UpdateSlip() {
        let errorList = [];
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        //updateUserId,updateUserName,updateUserEmailId,updatePlantName,updatePlantId,updateRolesId,updateRolesName

        if (errorList.length < 1) {
            let userUpdateDetails = {
                Id: editedrowData.id,
                UserId: updateUserId,
                UserName: updateUserName,
                EmailAddress: updateUserEmailId,
                PlantName: updatePlantName,
                UserRoleId: updateRolesId,
                UserRoleName: updateRolesName,
                IsActive: true,
                CreatedBy: null,
                CreatedDate: null,
                ModifiedBy: null,
                ModifiedDate: null,
                PlantId: updatePlantId,


            }
    if (userUpdateDetails.EmailAddress) {

        //validEmail.test(email)
        let validateData = validateEmail(userUpdateDetails.EmailAddress);
        if (!validateData) {
            errorList.push("Please enter Valid Email");

            showMessage(errorList, true, 'error');
            return;
        }
        //return;

    }
   
        
            api.put("/UpdateUser/", userUpdateDetails,{
                headers: headers,
            })
                .then(res => {
                    if (res.status == 200) {
                        if (res.data.result == 0) {
                            errorList.push("Failed to Update Record ,Please check your details");
                            showMessage(errorList, true, 'success');

                            setIserror(true);
                            getAllDetails();
                            setTimeout(() => {
                                props.setopenForm1(false);
                            }, [5000]);
                        } else {

                            errorList.push("Record were Updated successfully!!!");
                            showMessage(errorList, true, 'success');

                            setIserror(true);
                            getAllDetails();
                            setTimeout(() => {
                                props.setopenForm1(false);
                            }, [5000]);

                        }
                           

                        
                    }
                    
                })
                .catch(error => {
                    setErrorMessages(["Due to server error, we are unable to update the employee. Please try again, later."]);
                    setIserror(true);
                    // resolve();
                })

        } else {
            setErrorMessages(errorList);
            setIserror(true);
            //resolve();
        }
    }
   
   

    
   

   
   
    function showMessage(errorList, flag, severity) {
        setErrorMessages(errorList);
        setIserror(flag);
        setSeverity(severity);
    }

    return (
        <ThemeProvider theme={lightTheme}>
            <div className="master-layout-data">
                <Box paddingTop={{ xs: '5rem', sm: '2rem' }} className="">
                    <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1"> Update User Master</h3>
                </Box>
                <Grid container spacing={2} className="d-flex mt-1 fd-row mb-1 px-1 box-shadow width-100 bdr-radius ">
                   

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4} className="d-flex Width-100 mt-1 ">
                            <TextField className="lightInputFields"

                                disabled={true}
                                label="User Id"
                                variant="filled"
                                fullWidth
                                //name="Created Time"
                                onChange={handleUpdateUserId}
                                //disabled={userDetails.roleId == 1 || userDetails.roleId == 2 || userDetails.roleId == 3 || userDetails.roleId == 4 || userDetails.roleId == 5 || userDetails.roleId == 7 || userDetails.roleId == 8 || userDetails.roleId == 9 || userDetails.roleId == 10}
                                value={updateUserId}

                            />



                        </Grid>

                        <Grid item xs={12} sm={4} className="d-flex Width-100 mt-1 ">
                            <TextField className="lightInputFields"

                                //disabled={true}
                                label=" User Name"
                                variant="filled"
                                fullWidth
                                onChange={handleUpdateUserName}
                                //disabled={userDetails.roleId == 1 || userDetails.roleId == 2 || userDetails.roleId == 3 || userDetails.roleId == 4 || userDetails.roleId == 5 || userDetails.roleId == 7 || userDetails.roleId == 8 || userDetails.roleId == 9 || userDetails.roleId == 10}
                                value={updateUserName}


                            />
                        </Grid>

                        <Grid item xs={12} sm={4} className="d-flex Width-100 mt-1 ">
                            <TextField className="lightInputFields"

                                //disabled={true}
                                label=" Email Address"
                                variant="filled"
                                fullWidth
                                onChange={handleUpdateUserEmailId}
                                //disabled={userDetails.roleId == 1 || userDetails.roleId == 2 || userDetails.roleId == 3 || userDetails.roleId == 4 || userDetails.roleId == 5 || userDetails.roleId == 7 || userDetails.roleId == 8 || userDetails.roleId == 9 || userDetails.roleId == 10}
                                value={updateUserEmailId}


                            />
                        </Grid>
                        <Grid item xs={12} sm={4} className="d-flex Width-100  mt-1">
                            <TextField className="lightInputFields  "
                                select
                                id=""
                                //disabled={true}
                                label="Plant Name"
                                variant="filled"
                                fullWidth
                                name=""
                                value={updatePlantId}
                                onChange={handleUpdatePlantName}
                            >

                                {plantDNames.map((item) => (
                                    <MenuItem key={item.plantId} value={item.plantId}>
                                        {item.plantName}
                                    </MenuItem>
                                ))}
                            </TextField>


                        </Grid>

                        <Grid item xs={12} sm={4} className="d-flex Width-100  mt-1">
                            <TextField className="lightInputFields"
                                select
                                id="roledfiled"
                                //disabled={true}
                                label="Roles"
                                variant="filled"
                                fullWidth
                                name=""
                                value={updateRolesId}
                                onChange={handleUpdateRolesId}
                            >
                                {allRolesData.map((item) => (
                                    <MenuItem key={item.roleId} value={item.roleId}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                            </TextField>


                        </Grid>





                    </Grid>

                   


                    

                    <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
                        <Button className="ns-btn-primary mt-1 mr-1" onClick={UpdateSlip} >
                            <span>Update</span>
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
                        <Button className="ns-btn-primary mt-1 mr-1" onClick={clear} >
                            <span>Clear</span>
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
                        {/*<Link to={"/ModifyInventory"}>*/}
                        <Button className="ns-btn-primary mt-1 mr-1" onClick={backClick}  >
                            <span>Back</span>
                        </Button>
                        {/*        </Link>*/}
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex jc-center width-100">
                    </Grid>

                </Grid>

                <Dialog
                    open={openLoader}
                    //onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess"
                    PaperProps={{
                        style: {
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            borderColor: "transparent"
                        },
                    }}>
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>

                <Grid item xs={12} sm={12} className="userManagement mt-1 mb-1">
                    <div>
                        {iserror &&
                            <Alert severity={severity} onClose={handleErrorClose}>
                                {errorMessages.map((msg, i) => {
                                    return <div key={i}>{msg}</div>
                                })}
                            </Alert>
                        }
                    </div>
                </Grid>

            </div>
        </ThemeProvider>
    );
}


